import { useMemo } from 'react';
import { IReference } from '../references/IReference';
import { materializeReference } from './materializeReferencePath';

export function useMaterializeReference(name: string, reference: IReference) {
  const result = useMemo(() => {
    return materializeReference(reference, name);
  }, [name, reference]);

  return result;
}
